import { CARD_BOOLEAN_PROPERTIES, CARD_NUMBER_PROPERTIES, CARD_STRING_ARRAY_PROPERTIES, CARD_STRING_PROPERTIES, CardBooleanProperty, CardNumberProperty, CardStringArrayProperty, CardStringProperty } from "./Card";
import { CardVariant } from "./CardVariant";
import { MathComparisonSymbol, MathOperator } from "./Math";

export const CARD_TEXT_RULE_TYPES = ["isCrystalGenerator", "hasDamageXAbility", "isMultiElement"] as const;
export type CardTextRuleType = typeof CARD_TEXT_RULE_TYPES[number];

export const CARD_TEXT_RULE_NAMES: Record<CardTextRuleType, { key: CardTextRuleType, name: string }> = {
    hasDamageXAbility: { key: "hasDamageXAbility", name: "Damage X" },
    isCrystalGenerator: { key: "isCrystalGenerator", name: "Crystal Generator" },
    isMultiElement: { key: "isMultiElement", name: "Multi Element" }
}

export const CARD_RULE_CLASSIFICATIONS = ["search"] as const;
export type CardRuleClassification = typeof CARD_RULE_CLASSIFICATIONS[number];

export type CardRuleSets = {
    id: string,
    rules: CardRuleSet[]
}

export type CardRuleSet = {
    classification: CardRuleClassification,
    operator: MathOperator,
    rules: AnyCardRule[]
}

export type VariantRuleSet = {
    variant: CardVariant,
    rule: CardRuleSet
}

export type AnyCardRuleType = CardTextRuleType | CardStringProperty | CardStringArrayProperty | CardNumberProperty | CardBooleanProperty | "composite";
export type AnyCardRule = CardStringRule | CardStringArrayRule | CardNumberRule | CardTextRule | CardCompositeRule | CardBooleanRule;

export const CARD_RULE_CATEGORIES = ["CardTextRule", "CardStringRule", "CardStringArrayRule", "CardNumberRule", "CardBooleanRule", "CompositeRule"] as const;
export type CardRuleCategory = typeof CARD_RULE_CATEGORIES[number];

export type CardRule<TCategory extends CardRuleCategory, TType extends string> = {
    type: TType,
    category: TCategory,
    sign: MathComparisonSymbol
}

export type CardTextRule = CardRule<"CardTextRule", CardTextRuleType>;
export type CardStringRule = CardRule<"CardStringRule", CardStringProperty> & { value: string };
export type CardStringArrayRule = CardRule<"CardStringArrayRule", CardStringArrayProperty> & { value: string };
export type CardNumberRule = CardRule<"CardNumberRule", CardNumberProperty> & { value: number };
export type CardBooleanRule = CardRule<"CardBooleanRule", CardBooleanProperty> & { value: boolean };
export type CardCompositeRule = CardRule<"CompositeRule", "composite"> & { rules: AnyCardRule[], operator: MathOperator }

export type RuleResult = {
    expectedQuantity: number,
    expectedQuantityComparisonSymbol: MathComparisonSymbol,
    actualQuantity: number
}

export const MATH_COMPARISON_SYMBOL_TEXT_MAP: Record<MathComparisonSymbol, string> = {
    "<": "Less than ",
    "<=": "Less than or equal to ",
    "=": "",
    "!=": "Not equal to",
    ">": "Greater than ",
    ">=": "Greater than or equal to "
}

export const ALL_CARD_RULE_TYPES: AnyCardRuleType[] = [
    ...CARD_TEXT_RULE_TYPES,
    ...CARD_STRING_PROPERTIES,
    ...CARD_STRING_ARRAY_PROPERTIES,
    ...CARD_NUMBER_PROPERTIES,
    ...CARD_BOOLEAN_PROPERTIES,
    "composite"
];